<template >

  <div class="container " >
    <form action="" @submit.prevent="submit">
      <div class="card">
        <div class="card-header">
          <h6><i class="fa fa-address-book"></i><span class="tab-txt"> البيانات الاساسية </span></h6>
        </div>
        <div class="card-body">
          <div class="form row">
          <div class="form-group col-md-3 offset-md-9">
              <label for="">كود الموظف</label>
              <input
                type="text"
                class="form-control"
                disabled
                v-model.trim="$v.id.$model"
                :class="{
                  'is-invalid': $v.id.$error,
                  'is-valid': !$v.id.$invalid,
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.id.required">هذا الحقل مطلوب</span>
              </div>
            </div>
            <div class="form-group col-md-3">
              <label for="">الاسم الاول</label>
              <input
                type="text"
                class="form-control"
                v-model.trim="$v.Fname.$model"
                :class="{
                  'is-invalid': $v.Fname.$error,
                  'is-valid': !$v.Fname.$invalid,
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.Fname.required">هذا الحقل مطلوب</span>
                <span v-if="!$v.Fname.minLength"
                  >يجب ان يحتوى على الاقل على{{
                    $v.Fname.$params.minLength.min
                  }}</span
                >
                <span v-if="!$v.Fname.maxLength"
                  >اقصى عدد مسموح {{ $v.Fname.$params.maxLength.max }} حرف
                </span>
              </div>
            </div>
            <div class="form-group col-md-3">
              <label for="">الاسم الثانى</label>
              <input
                type="text"
                class="form-control"
                v-model.trim="$v.Sname.$model"
                :class="{
                  'is-invalid': $v.Sname.$error,
                  'is-valid': !$v.Sname.$invalid,
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.Sname.required">هذا الحقل مطلوب</span>
                <span v-if="!$v.Sname.minLength"
                  >يجب ان يحتوى على الاقل على{{
                    $v.Sname.$params.minLength.min
                  }}</span
                >
                <span v-if="!$v.Sname.maxLength"
                  >اقصى عدد مسموح {{ $v.Sname.$params.maxLength.max }} حرف
                </span>
              </div>
            </div>
            <div class="form-group col-md-3">
              <label for="">الاسم الثالث</label>
              <input
                type="text"
                class="form-control"
                v-model.trim="$v.Tname.$model"
                :class="{
                  'is-invalid': $v.Tname.$error,
                  'is-valid': !$v.Tname.$invalid,
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.Tname.required">هذا الحقل مطلوب</span>
                <span v-if="!$v.Tname.minLength"
                  >يجب ان يحتوى على الاقل على{{
                    $v.Tname.$params.minLength.min
                  }}</span
                >
                <span v-if="!$v.Tname.maxLength"
                  >اقصى عدد مسموح {{ $v.Tname.$params.maxLength.max }} حرف
                </span>
              </div>
            </div>
            <div class="form-group col-md-3">
              <label for="">اللقب</label>
              <input
                type="text"
                class="form-control"
                v-model.trim="$v.Ffname.$model"
                :class="{
                  'is-invalid': $v.Ffname.$error,
                  'is-valid': !$v.Ffname.$invalid,
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.Ffname.required">هذا الحقل مطلوب</span>
                <span v-if="!$v.Ffname.minLength"
                  >يجب ان يحتوى على الاقل على{{
                    $v.Ffname.$params.minLength.min
                  }}</span
                >
                <span v-if="!$v.Ffname.maxLength"
                  >اقصى عدد مسموح {{ $v.Ffname.$params.maxLength.max }} حرف
                </span>
              </div>
            </div>

              <div class="form-group col-md-3">
              <label for="">رقم البطاقة</label>
              <input
                type="number"
                class="form-control"
                v-model.number.number="$v.NationalId.$model"
                :class="{
                  'is-invalid': $v.NationalId.$error,
                  'is-valid': !$v.NationalId.$invalid,
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.NationalId.required">هذا الحقل مطلوب</span>
              </div>
            </div>
            <div class="form-group col-md-3">
              <label for="">الجوال</label>
              <input
                type="number"
                class="form-control"
                v-model.number.number="$v.Mob.$model"
                :class="{
                  'is-invalid': $v.Mob.$error,
                  'is-valid': !$v.Mob.$invalid,
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.Mob.required">هذا الحقل مطلوب</span>
                <span v-if="!$v.Mob.between">لابد من إدخال رقم جوال صحيح</span>
              </div>
            </div>
             <div class="form-group col-md-3">
              <label for="">2 الجوال</label>
              <input
                type="number"
                class="form-control"
                v-model.number.number="$v.Mob2.$model"
                :class="{
                  'is-invalid': $v.Mob2.$error,
                  'is-valid': !$v.Mob2.$invalid,
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.Mob2.between">لابد من إدخال رقم جوال صحيح</span>
              </div>
            </div>

           <div class="form-group col-md-3">
              <label for="">الجنسية</label>
              <select
                class="browser-default custom-select"
                v-model.trim="$v.nat_id.$model"
                :class="{
                  'is-invalid': $v.nat_id.$error,
                  'is-valid': !$v.nat_id.$invalid,
                }"
              >
             <option v-for="nat in nats" :value="nat.id" :key="nat.id">
           {{ nat.nName }}
            </option>
              </select>

              <div class="invalid-feedback">
                <span v-if="!$v.nat_id.required">هذا الحقل مطلوب</span>
              </div>
            </div>

             <div class="form-group col-md-3">
              <label for="">تاريخ الميلاد</label>
             
              <input
                id="birthdate"
                type="text"
                @blur="birthdate1"
             
                class="form-control hijri-date-input"
                 v-bind:value="$v.birthdate.$model"
                :class="{
                  'is-invalid': $v.birthdate.$error,
                  'is-valid': !$v.birthdate.$invalid,  
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.birthdate.required">هذا الحقل مطلوب</span>
              </div>
            </div>

        <div class="form-group col-md-3">
              <label for="">العنوان</label>
              <input
                type="text"
                class="form-control"
                v-model.trim="$v.Address.$model"
                :class="{
                  'is-invalid': $v.Address.$error,
                  'is-valid': !$v.Address.$invalid,
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.Address.minLength"
                  >يجب ان يحتوى على الاقل على{{
                    $v.Address.$params.minLength.min
                  }}</span
                >
                <span v-if="!$v.Address.maxLength"
                  >اقصى عدد مسموح
                  {{ $v.Address.$params.maxLength.max }}</span
                >
              </div>
            </div>
 <div class="form-group col-md-3">
              <label for="">الوظيفة</label>
              <select
                class="browser-default custom-select"
                v-model.trim="$v.job_id.$model"
                :class="{
                  'is-invalid': $v.job_id.$error,
                  'is-valid': !$v.job_id.$invalid,
                }"
              >
             <option v-for="job in jobs" :value="job.id" :key="job.id">
           {{ job.job }}
            </option>
              </select>

              <div class="invalid-feedback">
                <span v-if="!$v.job_id.required">هذا الحقل مطلوب</span>
              </div>
            </div>
 <div class="form-group col-md-3">
              <label for="">تاريخ بداية الرخصة </label>
             
              <input
                id="driverLcStart"
                type="text"
                @blur="driverLcStart1"
             
                class="form-control hijri-date-input"
                 v-bind:value="$v.driverLcStart.$model"
                :class="{
                  'is-invalid': $v.driverLcStart.$error,
                  'is-valid': !$v.driverLcStart.$invalid,  
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.driverLcStart.required">هذا الحقل مطلوب</span>
              </div>
            </div>

            <div class="form-group col-md-3">
              <label for="">تاريخ نهاية الرخصة </label>
             
              <input
                id="driverLcEnd"
                type="text"
                @blur="driverLcEnd1"
             
                class="form-control hijri-date-input"
                 v-bind:value="$v.driverLcEnd.$model"
                :class="{
                  'is-invalid': $v.driverLcEnd.$error,
                  'is-valid': !$v.driverLcEnd.$invalid,  
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.driverLcEnd.required">هذا الحقل مطلوب</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
            <h6><i class="fa fa-database"></i><span class="tab-txt"> بيانات التعاقد </span></h6>
        </div>
        <div class="card-body">
          <div class="form row">
 
  <div class="form-group col-md-3 ">
              <label for="">كود الباص</label>
              <input
                type="text"
                class="form-control"
                v-model.trim="$v.bus_id.$model"
                :class="{
                  'is-invalid': $v.bus_id.$error,
                  'is-valid': !$v.bus_id.$invalid,
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.bus_id.required">هذا الحقل مطلوب</span>
              </div>
            </div>
    <div class="form-group col-md-3">
              <label for="">رقم العقد</label>
              <input
                type="text"
                class="form-control"
                v-model.trim="$v.driverContractNum.$model"
                :class="{
                  'is-invalid': $v.driverContractNum.$error,
                  'is-valid': !$v.driverContractNum.$invalid,
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.driverContractNum.minLength"
                  >يجب ان يحتوى على الاقل على{{
                    $v.driverContractNum.$params.minLength.min
                  }}</span
                >
                <span v-if="!$v.driverContractNum.maxLength"
                  >اقصى عدد مسموح
                  {{ $v.driverContractNumdriverContractNum.$params.maxLength.max }}</span
                >
              </div>
            </div>
   <div class="form-group col-md-3">
              <label for="">تاريخ بداية الاقامة </label>
             
              <input
                id="accoStart"
                type="text"
                @blur="accoStart1"
             
                class="form-control hijri-date-input"
                 v-bind:value="$v.accoStart.$model"
                :class="{
                  'is-invalid': $v.accoStart.$error,
                  'is-valid': !$v.accoStart.$invalid,  
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.accoStart.required">هذا الحقل مطلوب</span>
              </div>
            </div>

             <div class="form-group col-md-3">
              <label for="">تاريخ نهاية الاقامة </label>
             
              <input
                id="accoEnd"
                type="text"
                @blur="accoEnd1"
             
                class="form-control hijri-date-input"
                 v-bind:value="$v.accoEnd.$model"
                :class="{
                  'is-invalid': $v.accoEnd.$error,
                  'is-valid': !$v.accoEnd.$invalid,  
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.accoEnd.required">هذا الحقل مطلوب</span>
              </div>
            </div>
            
           

 
            <div class="form-group col-md-3">
              <label for="">خط السير من</label>
              <select
                class="browser-default custom-select"
                v-model.trim="$v.trafficFrom.$model"
                :class="{
                  'is-invalid': $v.trafficFrom.$error,
                  'is-valid': !$v.trafficFrom.$invalid,
                }"
              >
             <option v-for="workarea in workarea" :value="workarea.id" :key="workarea.id">
           {{ workarea.areaName }}
            </option>
              </select>

              <div class="invalid-feedback">
                <span v-if="!$v.trafficFrom.required">هذا الحقل مطلوب</span>
              </div>
            </div>

             <div class="form-group col-md-3">
              <label for="">خط السير الى </label>
              <select
                class="browser-default custom-select"
                v-model.trim="$v.trafficTo.$model"
                :class="{
                  'is-invalid': $v.trafficTo.$error,
                  'is-valid': !$v.trafficTo.$invalid,
                }"
              >
             <option v-for="traffic in traffic" :value="traffic.id" :key="traffic.id">
           {{ traffic.trafficTo }}
            </option>
              </select>

              <div class="invalid-feedback">
                <span v-if="!$v.trafficTo.required">هذا الحقل مطلوب</span>
              </div>
            </div>
   <div class="form-group col-md-3 ">
              <label for="">الراتب</label>
              <input
                type="text"
                class="form-control"
                v-model.trim="$v.Salary.$model"
                :class="{
                  'is-invalid': $v.Salary.$error,
                  'is-valid': !$v.Salary.$invalid,
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.Salary.required">هذا الحقل مطلوب</span>
              </div>
            </div>
               <div class="form-group col-md-3 ">
              <label for="">النسبة</label>
              <input
                type="text"
                class="form-control"
                v-model.trim="$v.percentage.$model"
                :class="{
                  'is-invalid': $v.percentage.$error,
                  'is-valid': !$v.percentage.$invalid,
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.percentage.required">هذا الحقل مطلوب</span>
              </div>
            </div> 

 <div class="form-group col-md-3">

              <label for="">اسم الكفيل</label>
              <input
                type="text"
                class="form-control"
                v-model.trim="$v.Kafel.$model"
                :class="{
                  'is-invalid': $v.Kafel.$error,
                  'is-valid': !$v.Kafel.$invalid,
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.Kafel.required">هذا الحقل مطلوب</span>
                <span v-if="!$v.Kafel.minLength"
                  >يجب ان يحتوى على الاقل على{{
                    $v.Kafel.$params.minLength.min
                  }}</span
                >
                <span v-if="!$v.Kafel.maxLength"
                  >اقصى عدد مسموح {{ $v.Kafel.$params.maxLength.max }} حرف
                </span>
              </div>
            </div>
            <div class="form-group col-md-3">
              <label for="">جوال الكفيل</label>
              <input
                type="number"
                class="form-control"
                v-model.number.number="$v.kafelNum.$model"
                :class="{
                  'is-invalid': $v.kafelNum.$error,
                  'is-valid': !$v.kafelNum.$invalid,
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.kafelNum.between">لابد من إدخال رقم جوال صحيح</span>
              </div>
            </div>

                  <div class="form-group col-md-3">
              <label for="">معه العائلة</label>
              <input
                type="text"
                class="form-control"
                v-model.trim="$v.withFamily.$model"
                :class="{
                  'is-invalid': $v.withFamily.$error,
                  'is-valid': !$v.withFamily.$invalid,
                }"
              />
              <div class="invalid-feedback">
                <span v-if="!$v.withFamily.minLength"
                  >يجب ان يحتوى على الاقل على{{
                    $v.withFamily.$params.minLength.min
                  }}</span
                >
                <span v-if="!$v.withFamily.maxLength"
                  >اقصى عدد مسموح
                  {{ $v.withFamily.$params.maxLength.max }}</span
                >
              </div>
            </div>


          </div>
        </div>
                      <div class="card">
          <div class="card-header">
            <h6><i class="fa fa-paperclip"></i><span class="tab-txt"> معاملات </span></h6>
          </div>
          <div class="card-body">
            <div class="form row">
             
                   <router-link  :to="{name: 'empContract', path: '/empContract',params:{id: id}}"
            ><button class="btn btn-info">طباعة العقد</button></router-link
          >
          <button class="btn btn-primary mr-5" @click.prevent="printBill">طباعة كشف حساب</button>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <h6><i class="fa fa-cog"></i><span class="tab-txt"> التحكم </span></h6>
          </div>
          <div class="card-body">
            <div class="form row">
              <button
                class="btn btn-success"
                type="submit"
                :disabled="submitStatus === 'انتظار'"
              >
              <b-spinner
v-if="busy"
small
type="grow"
style="margin-bottom: 3px;"
></b-spinner>
              <i class="fa fa-paper-plane"></i>
               <span> {{submitStatus}} </span>
              </button>
               <b-button
                class="btn btn-info mr-3"
                type="button"
                to="/emps"
              >
              <i class="fa fa-undo"></i>
               <span> عودة </span>
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </form>

  </div>
</template>





<script>
  import { mapState,mapActions  } from 'vuex';
 import $ from 'jquery'
import indexLayout from "../../layouts/indexLayout.vue";


import {
  required,
  minLength,
  maxLength,
  between,
} from "vuelidate/lib/validators";
export default {
  name: "createEmp",
  data() {
    return {
     id:0,      
     Fname:"",
     Sname:"",
     Tname:"",
     Ffname:"",
     nat_id:"",
     birthdate:"",
     Mob:"",
     Mob2:"",
     NationalId:"",
     Address:"",
     job_id:"",
     Kafel:"",
     kafelNum:"",
     accoStart:"",
     accoEnd:"",
     driverLcStart:"",
     driverLcEnd:"",
     bus_id:"",
     driverContractNum:"",
     trafficFrom:"",
     trafficTo:"",
     Salary:"",
     percentage:"",
     withFamily:"",
     busy:false,
      submitStatus: "حفظ",
    };
  },
  validations: {
    id: { required },
    Fname: { required, minLength: minLength(2), maxLength: maxLength(15) },
    Sname: { required, minLength: minLength(2), maxLength: maxLength(15) },
    Tname: { required, minLength: minLength(2), maxLength: maxLength(15) },
    Ffname: { required, minLength: minLength(2), maxLength: maxLength(15) },
    nat_id: { required },
    birthdate: { required },
    NationalId: { required },
    Mob: { required, between: between(100000000, 100000000000) },
    Mob2: { between: between(100000000, 100000000000) },
    Address: {
      minLength: minLength(5),
      maxLength: maxLength(250),
    },
    job_id: { required },
    bus_id: { required },
    Salary: { required },
    percentage: { required },
    trafficFrom: { required },
    trafficTo: { required },
      withFamily: {
      minLength: minLength(1),
      maxLength: maxLength(250),
    },
      driverContractNum: {
      minLength: minLength(1),
      maxLength: maxLength(250),
    },
    Kafel: {
      required,
      minLength: minLength(5),
      maxLength: maxLength(250),
    },
    kafelNum: { between: between(100000000, 100000000000) },

    accoStart: { required,
    isUnique(value) {
        if (value === "") return true;
        var email_regx = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve(email_regx.test(value));
          }, 350 + Math.random() * 300);
        });
    }
    },
    accoEnd: { required,
    isUnique(value) {
        if (value === "") return true;
        var email_regx = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve(email_regx.test(value));
          }, 350 + Math.random() * 300);
        });
    }
    },
    driverLcStart: { required,
    isUnique(value) {
        if (value === "") return true;
        var email_regx = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve(email_regx.test(value));
          }, 350 + Math.random() * 300);
        });
    }
    },driverLcEnd: { required,
    isUnique(value) {
        if (value === "") return true;
        var email_regx = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve(email_regx.test(value));
          }, 350 + Math.random() * 300);
        });
    }
    },
  

  },
  methods: {
   ...mapActions('empMod',['updateData']),
    loadDataRow(){
       this.id = this.$route.params.id;
       var std  =  this.$store.getters['empMod/getTodoById'](this.id);
      this.id = std['id'] 
      this.Fname= std['Fname'] 
      this.Sname= std['Sname'] 
      this.Tname= std['Tname'] 
      this.Ffname= std['Ffname'] 
      this.nat_id= std['nat_id']
      this.birthdate= std['birthdate']
      this.NationalId= std['NationalId']
      this.Mob= std['Mob']
      this.Address= std['Address']
      this.job_id= std['job_id']
      this.Kafel= std['Kafel']
      this.kafelNum= std['kafelNum']
      this.withFamily= std['withFamily']
      this.accoStart= std['accoStart']
      this.accoEnd= std['accoEnd']
      this.driverLcStart= std['driverLcStart']
      this.driverLcEnd= std['driverLcEnd']
      this.bus_id= std['bus_id']
      this.driverContractNum= std['driverContractNum']
      this.trafficFrom= std['trafficFrom']
      this.trafficTo= std['trafficTo']
      this.Salary= std['Salary']
      this.percentage= std['percentage']
     
   },
  birthdate1(){
        var st = $('#birthdate').val();
        this.birthdate = st;
   },
  accoStart1(){
        var st = $('#accoStart').val();
        this.accoStart = st;
   },  accoEnd1(){
        var ed = $('#accoEnd').val();
        this.accoEnd = ed;
   }, driverLcStart1(){
        var ed = $('#driverLcStart').val();
        this.driverLcStart = ed;
   }, driverLcEnd1(){
        var ed = $('#driverLcEnd').val();
        this.driverLcEnd = ed;
   },
   async submit() {
      this.$v.$touch();
      this.busy=true;
      if (this.$v.$invalid) {
        this.submitStatus = "خطأ";
        this.busy=false;
      } else {
       var std = {
        id:this.id,   
        Fname:this.Fname,
        Sname:this.Sname,
        Tname:this.Tname,
        Ffname:this.Ffname,
        nat_id:this.nat_id,
        birthdate:this.birthdate,
        NationalId:this.NationalId,
        Mob:this.Mob,
        Mob2:this.Mob2,
        Address:this.Address,
        job_id:this.job_id,
        Kafel:this.Kafel,
        kafelNum:this.kafelNum,
        withFamily:this.fml,
        accoStart:this.accoStart,
        accoEnd:this.accoEnd,
        driverLcStart:this.driverLcStart,
        driverLcEnd:this.driverLcEnd,
        bus_id:this.bus_id,
        driverContractNum:this.driverContractNum,
        trafficFrom:this.trafficFrom,
        trafficTo:this.trafficTo,
        Salary:this.Salary,
         percentage:this.percentage,
}
         await  this.updateData(std);       

        this.submitStatus = "الانتظار";
        setTimeout(() => {
          this.submitStatus = "تم الحفظ";
        }, 500);
        this.busy=false;
      }
    },
  },created(){

let ckeditor = document.createElement('script'); 
//ckeditor.setAttribute('src',"/load.js");
ckeditor.innerHTML = "$(function () { initHijrDatePicker();  });";
document.head.appendChild(ckeditor);
this.loadDataRow();
this.$emit('update:layout',indexLayout)

  }
  ,mounted(){
    
  
  },
  computed: mapState([
    'nats',     
    'jobs',       
    'workarea',
    'traffic' 
  ])
};
</script>

<style lang="scss" scoped>
span{
  font-size: 12px;
}
</style>
